<template>
    <div>
       <h4 class="title">權益與培訓專區</h4>
       <div class="member_content">
            <table class="table table-bordered">
                <caption>
                </caption>
                <thead>
                    <tr class="success">
                        <td>主題</td>
                        <td>檔案</td>
                        <td>日期</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(row, index) in this.training">
                      <td>{{row.title}}</td>
                      <td v-html="row.content"></td>
                      <td>{{row.created_at}}</td>
                    </tr>
                </tbody>
            </table>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Training',
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      training: []
    }
  },
  mounted: function () {
    this.$http.get(this.memberurl + '/training', {params: {token: this.token}}).then(function (res) {
      let data = res.body.data
      this.training = data
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ])
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Training.vue?0daf8f80